import React, { useState } from 'react';
import clsx from 'clsx';
import { CaretRight } from '@gbm-tech/icons';

import {
  Popover as PopoverComponent,
  PopoverTrigger,
  PopoverWrapper,
} from './SidebarItemMenuCollapsed';
import { PageItem } from './PageItem';
import { PageItemCollapsed } from './PageItemCollapsed';
import { SubItem } from './SubItem';
import { SubItemCollapsed } from './SubItemCollapsed';
import { SidebarModule } from 'src/dtos';

import {
  ItemCollapsedContainer,
  ItemContainer,
  SidebarItemMenuCollapsedContainer,
  SidebarItemMenuContainer,
  SubItemCollapsedContainer,
  SubItemsContainer,
} from './styles';

export type SidebarItemMenuProps = {
  isSidebarOpen: boolean;
  module: SidebarModule;
};

export const SidebarItemMenu: React.FC<SidebarItemMenuProps> = ({
  isSidebarOpen,
  module,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubMenuCollapsedOpen, setIsSubMenuCollapsedOpen] = useState(false);

  function toggleMenu() {
    setIsMenuOpen(!isMenuOpen);
  }

  if (isSidebarOpen) {
    return (
      <SidebarItemMenuContainer title={module.name}>
        <ItemContainer onClick={toggleMenu}>
          <div className="icon">{module.icon}</div>

          <span>{module.name}</span>

          <div
            className={clsx('arrow', {
              'is-open': isMenuOpen,
            })}
          >
            <CaretRight />
          </div>
        </ItemContainer>

        <SubItemsContainer visible={isMenuOpen}>
          {module.pages.map((page) => (
            <PageItem key={`page ${page.id}`} page={page} />
          ))}

          {module.submodules.map((subItem) => (
            <SubItem key={`subItem ${subItem.id}`} subItem={subItem} />
          ))}
        </SubItemsContainer>
      </SidebarItemMenuContainer>
    );
  }

  return (
    <SidebarItemMenuCollapsedContainer>
      <PopoverComponent open={isSubMenuCollapsedOpen}>
        <PopoverTrigger>
          <ItemCollapsedContainer
            onMouseEnter={() => setIsSubMenuCollapsedOpen(true)}
            onMouseLeave={() => setIsSubMenuCollapsedOpen(false)}
          >
            <div className="icon">{module.icon}</div>
          </ItemCollapsedContainer>
        </PopoverTrigger>

        <PopoverWrapper
          onMouseEnter={() => setIsSubMenuCollapsedOpen(true)}
          onMouseLeave={() => setIsSubMenuCollapsedOpen(false)}
        >
          <SubItemCollapsedContainer>
            <strong>{module.name}</strong>

            {module.pages.map((page) => (
              <PageItemCollapsed key={`pageCollapsed ${page.id}`} page={page} />
            ))}

            {module.submodules.map((subItem, index) => (
              <SubItemCollapsed
                key={`${subItem.name} ${index + 101 * Math.random()}`}
                subItem={subItem}
              />
            ))}
          </SubItemCollapsedContainer>
        </PopoverWrapper>
      </PopoverComponent>
    </SidebarItemMenuCollapsedContainer>
  );
};
